module.exports = __webpack_public_path__ + "img/footer.bff2888a.png";